const DEFAULT_STREAM_ID = 1;
const VIEWER_URL_PATTERN = /^wss?:\/\//i;

/** Portal executeSurveillanceCommand body for live Web viewing (no client field). */
export function buildStartViewingCommandPayload(streamId = DEFAULT_STREAM_ID) {
  return {
    data: {
      command: "startViewing",
      params: {
        streamId,
        type: "Web",
      },
    },
  };
}

function pickViewerUrl(value) {
  if (typeof value === "string" && VIEWER_URL_PATTERN.test(value.trim())) {
    return value.trim();
  }
  return "";
}

/**
 * Parse viewer WebSocket URL from executeSurveillanceCommand (startViewing) response.
 *
 * Expected shape:
 * {
 *   "result": {
 *     "status": "success",
 *     "data": {
 *       "relay": {
 *         "clientStreamUrl": "wss://…/liveview/viewer/ws/{sessionId}"
 *       }
 *     }
 *   }
 * }
 */
export function extractViewingStreamUrl(response) {
  if (!response) return "";

  const primary = pickViewerUrl(response.result?.data?.relay?.clientStreamUrl);
  if (primary) return primary;

  const layers = [
    response.result?.data,
    response.data,
    response.result,
    response,
  ].filter(Boolean);

  for (const layer of layers) {
    const fromRelay = pickViewerUrl(layer.relay?.clientStreamUrl);
    if (fromRelay) return fromRelay;

    const direct = pickViewerUrl(layer);
    if (direct) return direct;

    const nested = [
      layer.url,
      layer.clientStreamUrl,
      layer.viewerUrl,
      layer.viewerWsUrl,
      layer.wsUrl,
      layer.endpoint,
      layer.viewer?.url,
      layer.viewer?.wsUrl,
    ];
    for (const candidate of nested) {
      const url = pickViewerUrl(candidate);
      if (url) return url;
    }
  }

  return "";
}

/** Returns an error message when startViewing command did not succeed. */
export function getStartViewingCommandError(response) {
  if (!response) return "Empty startViewing response";

  const apiError = response.error || response.result?.error;
  if (apiError?.message) return apiError.message;

  const status = response.result?.status;
  if (status && status !== "success") {
    return response.result?.message || `startViewing failed (${status})`;
  }

  if (!extractViewingStreamUrl(response)) {
    return "startViewing response missing relay.clientStreamUrl";
  }

  return null;
}

export function relayProtocolFromEndpoint(endpoint) {
  if (!endpoint) return "ws";
  return endpoint.startsWith("wss:") ? "wss" : "ws";
}
